import { GallerySection, Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateGallery = generateAPI<
  {
    body: {
      gallery: GallerySection[];
    };
  },
  Wedding
>("put", "wedding/gallery", "wedding/");
